import axios from 'axios'
import {
  interceptorErrorHandler,
  interceptorResponseHandler
} from './interceptor'

const HTTP_CLIENT_TIMEOUT = 5000

class HttpClient {
  constructor() {
    if (!HttpClient.instance) {
      HttpClient.instance = axios.create({
        timeout: HTTP_CLIENT_TIMEOUT,
        withCredentials: true,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      })

      HttpClient.instance.interceptors.response.use(
        interceptorResponseHandler,
        interceptorErrorHandler
      )

      Object.freeze(HttpClient.instance)
    }
  }

  getInstance() {
    return HttpClient.instance
  }
}

const httpClient = new HttpClient()

export default httpClient
